import React from 'react';

export const FeaturesGrid = () => (
  <>
    <div
      style={{
        position: 'absolute',
        width: 855.3,
        height: 731.4,
        left: 'calc(50% - 855.3px / 2 - 0.35px)',
        top: 1700,
      }}
    >

      {/* ---------- Frame 4 ---------- */}
      <svg width="490px" height="291px" viewBox="0 0 490 291" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute',left: -33, top: -51.5,}}>
      <foreignObject x="0.764704" y="0.447203" width="488.7" height="289.8">
          <div
            style={{
              position: 'absolute',
              width: 270,
              height: 39,
              top: 85,
              left: 148,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 34.4,
              lineHeight: '39px',
              textAlign: 'left',
              color: '#FFFFFF',
              zIndex: 22
            }}
          >
            AI Trade Analysis
          </div>
          <div
            style={{
              paddingTop: "70px",
              position: 'absolute',
              width: 356.5,
              height: 126.9,
              left: 'calc(50% - 346.5px / 2 - 8.1px)',
              top: 85,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 26,
              lineHeight: '26px',
              textAlign: 'left',
              color: 'rgba(255, 255, 255, 0.8)',
              zIndex: 22
            }}
          >
            Advanced pattern recognition and market structure analysis
          </div>
          <div
            style={{
              position: 'absolute',
              width: 251,
              height: 7.2,
              left: 170,
              top: 135,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 45,
              zIndex: 22
            }}
          />
        <div
          style={{
            position: 'absolute',
            width: 80.1,
            height: 80.1,
            left: 38,
            top: 54,
            background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.93181px 1.80041px 8.316px rgba(255,255,255,0.126),
                        inset 1.09553px 1.02101px 4.158px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(6.822px)',
            borderRadius: '50%',
            zIndex: 22
          }}
        >
          {/* Иконка-график */}
          <svg width="42" height="52" viewBox="0 0 42 52" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "18.8px", top: "16px"}}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M23.8682 1.71101C25.3139 -0.0229198 28.1298 1.16201 27.9011 3.40833L26.2861 19.1875H39.35C39.7847 19.1877 40.2103 19.3117 40.577 19.545C40.9438 19.7783 41.2364 20.1113 41.4208 20.5049C41.6051 20.8985 41.6735 21.3365 41.6179 21.7676C41.5623 22.1987 41.385 22.605 41.1068 22.939L18.2318 50.389C16.7861 52.1229 13.9702 50.938 14.199 48.6917L15.8139 32.9125H2.75002C2.31537 32.9123 1.88975 32.7883 1.52302 32.555C1.15628 32.3217 0.863615 31.9888 0.679279 31.5951C0.494943 31.2015 0.426572 30.7635 0.482172 30.3324C0.537772 29.9013 0.715042 29.495 0.993223 29.161L23.8682 1.71101ZM7.63384 28.3375H19.8674C19.9953 28.3375 20.1217 28.3643 20.2386 28.4162C20.3555 28.4681 20.4602 28.5439 20.546 28.6387C20.6318 28.7335 20.6967 28.8453 20.7366 28.9668C20.7766 29.0883 20.7906 29.2168 20.7778 29.344L19.5128 41.7079L34.4662 23.7625H22.2327C22.1048 23.7625 21.9783 23.7357 21.8614 23.6838C21.7446 23.6319 21.6399 23.5561 21.5541 23.4613C21.4683 23.3665 21.4033 23.2547 21.3634 23.1332C21.3235 23.0117 21.3094 22.8832 21.3222 22.756L22.5872 10.3944L7.63384 28.3375Z" fill="white"/>
          </svg>
        </div>
        <div
          style={{
            backdropFilter: 'blur(4.39px)',
            clipPath: 'url(#bgblur_0_2_164_clip_path)',
            height: '100%',
            width: '100%',
            inset: 0,
            zIndex: 0
          }}
        />
      </foreignObject><g filter="url(#filter0_ddii_2_164)" data-figma-bg-blur-radius="8.784" transform="scale(1)" style={{boxShadow: `-10.0354px -9.3528px 43.2px rgba(0,0,0,0.15),-1.67256px -1.5588px 10.8px rgba(0,0,0,0.15),inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,backdropFilter: 'blur(4.392px)',transform:`matrix(-1, 0, 0, 1, 490, 0)`}}>
      
      <path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z" fill="#7F38F3" fill-opacity="0.15" style={{mixBlendMode:"plus-lighter"}}/>
      </g>
      <defs>
      <filter id="filter0_ddii_2_164" x="0.764704" y="0.447203" width="488.7" height="289.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1.67256" dy="-1.5588"/>
      <feGaussianBlur stdDeviation="5.4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="BackgroundImageFix" result="effect1_dropShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-10.0354" dy="-9.3528"/>
      <feGaussianBlur stdDeviation="21.6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="effect1_dropShadow_2_164" result="effect2_dropShadow_2_164"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_164" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.970085" dy="0.904104"/>
      <feGaussianBlur stdDeviation="1.944"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="shape" result="effect3_innerShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1.80636" dy="1.6835"/>
      <feGaussianBlur stdDeviation="3.888"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="effect3_innerShadow_2_164" result="effect4_innerShadow_2_164"/>
      </filter>
      <clipPath id="bgblur_0_2_164_clip_path" transform="translate(-0.764704 -0.447203)"><path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z"/>
      </clipPath></defs>
      </svg>
      

      {/* ---------- Frame 5 ---------- */}
      <svg width="490px" height="291px" viewBox="0 0 490 291" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute',left: 399, top: -51.5,transform: 'matrix(-1, 0, 0, 1, 0, 0)'}}>
      <foreignObject x="0.764704" y="0.447203" width="488.7" height="289.8">
          <div
            style={{
              position: 'absolute',
              width: 270,
              height: 39,
              top: 85,
              left: 148,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 34.4,
              lineHeight: '39px',
              textAlign: 'left',
              color: '#FFFFFF',
              transform: 'scaleX(-1)',
              zIndex: 22
            }}
          >
            Swing Trading
          </div>
          <div
            style={{
              paddingTop: "70px",
              position: 'absolute',
              width: 356.5,
              height: 126.9,
              left: 'calc(50% - 346.5px / 2 - 8.1px)',
              top: 85,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 26,
              lineHeight: '26px',
              textAlign: 'left',
              color: 'rgba(255, 255, 255, 0.8)',
              transform: 'scaleX(-1)',
              zIndex: 22
            }}
          >
            Multi-day to multi-week trading opportunities analysis
          </div>
          <div
            style={{
              position: 'absolute',
              width: 251,
              height: 7.2,
              left: 170,
              top: 135,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 45,
              zIndex: 22
            }}
          />
        <div
          style={{
            position: 'absolute',
            width: 80.1,
            height: 80.1,
            left: 38,
            top: 54,
            background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.93181px 1.80041px 8.316px rgba(255,255,255,0.126),
                        inset 1.09553px 1.02101px 4.158px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(6.822px)',
            borderRadius: '50%',
            zIndex: 22
          }}
        >
          {/* Иконка-график */}
          <svg width="50" height="30" viewBox="0 0 50 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "13.8px", top: "25px",transform:"scaleX(-1)"}}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.91078 28.408C6.24734 29.0714 5.34751 29.4441 4.40926 29.4441C3.47101 29.4441 2.57119 29.0714 1.90774 28.408C1.2443 27.7445 0.871582 26.8447 0.871582 25.9064C0.871582 24.9682 1.2443 24.0684 1.90774 23.4049L13.6923 11.6239L13.717 11.5992C14.6799 10.6561 15.9739 10.128 17.3217 10.128C18.6694 10.128 19.9635 10.6561 20.9264 11.5992L20.9511 11.6239L26.9654 17.6382L35.2637 8.86252L31.5865 5.18538C31.2161 4.81453 30.964 4.34224 30.8618 3.82815C30.7597 3.31406 30.8122 2.78124 31.0127 2.29697C31.2132 1.81271 31.5528 1.39873 31.9884 1.10732C32.4241 0.815903 32.9363 0.660129 33.4605 0.659668H46.3764C47.0797 0.659668 47.7542 0.939051 48.2515 1.43636C48.7488 1.93366 49.0282 2.60816 49.0282 3.31145V16.2239C49.0277 16.748 48.872 17.2603 48.5806 17.6959C48.2891 18.1316 47.8752 18.4711 47.3909 18.6716C46.9066 18.8721 46.3738 18.9246 45.8597 18.8225C45.3456 18.7204 44.8733 18.4682 44.5025 18.0978L40.2667 13.862L30.7061 23.9777L30.6107 24.0732C29.6478 25.0162 28.3538 25.5444 27.006 25.5444C25.6583 25.5444 24.3642 25.0162 23.4014 24.0732L23.3766 24.0484L17.3199 17.9953L6.91078 28.408Z" fill="white"/>
          </svg>
        </div>
        <div
          style={{
            backdropFilter: 'blur(4.39px)',
            clipPath: 'url(#bgblur_0_2_164_clip_path)',
            height: '100%',
            width: '100%',
            inset: 0,
            zIndex: 0
          }}
        />
      </foreignObject><g filter="url(#filter0_ddii_2_164)" data-figma-bg-blur-radius="8.784" transform="scale(1)" style={{boxShadow: `-10.0354px -9.3528px 43.2px rgba(0,0,0,0.15),-1.67256px -1.5588px 10.8px rgba(0,0,0,0.15),inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,backdropFilter: 'blur(4.392px)',transform:`matrix(-1, 0, 0, 1, 490, 0)`}}>
      
      <path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z" fill="#7F38F3" fill-opacity="0.15" style={{mixBlendMode:"plus-lighter"}}/>
      </g>
      <defs>
      <filter id="filter0_ddii_2_164" x="0.764704" y="0.447203" width="488.7" height="289.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1.67256" dy="-1.5588"/>
      <feGaussianBlur stdDeviation="5.4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="BackgroundImageFix" result="effect1_dropShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-10.0354" dy="-9.3528"/>
      <feGaussianBlur stdDeviation="21.6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="effect1_dropShadow_2_164" result="effect2_dropShadow_2_164"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_164" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.970085" dy="0.904104"/>
      <feGaussianBlur stdDeviation="1.944"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="shape" result="effect3_innerShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1.80636" dy="1.6835"/>
      <feGaussianBlur stdDeviation="3.888"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="effect3_innerShadow_2_164" result="effect4_innerShadow_2_164"/>
      </filter>
      <clipPath id="bgblur_0_2_164_clip_path" transform="translate(-0.764704 -0.447203)"><path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z"/>
      </clipPath></defs>
      </svg>
      //-----------------------------------


      {/* ---------- Frame 6 ---------- */}
      <svg width="490px" height="291px" viewBox="0 0 490 291" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute',left: -33, top: 192.5,}}>
      <foreignObject x="0.764704" y="0.447203" width="488.7" height="289.8">
          <div
            style={{
              position: 'absolute',
              width: 270,
              height: 39,
              top: 85,
              left: 148,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 34.4,
              lineHeight: '39px',
              textAlign: 'left',
              color: '#FFFFFF',
              zIndex: 22
            }}
          >
            Scalp Trading
          </div>
          <div
            style={{
              paddingTop: "70px",
              position: 'absolute',
              width: 356.5,
              height: 126.9,
              left: 'calc(50% - 346.5px / 2 - 8.1px)',
              top: 85,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 26,
              lineHeight: '26px',
              textAlign: 'right',
              color: 'rgba(255, 255, 255, 0.8)',
              zIndex: 22
            }}
          >
            Ultra-short term trading 
            <br></br>opportunities for quick profits
          </div>
          <div
            style={{
              position: 'absolute',
              width: 251,
              height: 7.2,
              left: 170,
              top: 135,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 45,
              zIndex: 22
            }}
          />
        <div
          style={{
            position: 'absolute',
            width: 80.1,
            height: 80.1,
            left: 38,
            top: 54,
            background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.93181px 1.80041px 8.316px rgba(255,255,255,0.126),
                        inset 1.09553px 1.02101px 4.158px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(6.822px)',
            borderRadius: '50%',
            zIndex: 22
          }}
        >
          {/* Иконка-график */}
          <svg width="63" height="62" viewBox="0 0 63 62" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "9.5px", top: "12px",transform:"scaleX(-1)"}}>
            <path d="M8.14996 31H18.4833L26.2333 49.0833L36.5666 12.9166L44.3166 31H54.65" stroke="white" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div
          style={{
            backdropFilter: 'blur(4.39px)',
            clipPath: 'url(#bgblur_0_2_164_clip_path)',
            height: '100%',
            width: '100%',
            inset: 0,
            zIndex: 0
          }}
        />
      </foreignObject><g filter="url(#filter0_ddii_2_164)" data-figma-bg-blur-radius="8.784" transform="scale(1)" style={{boxShadow: `-10.0354px -9.3528px 43.2px rgba(0,0,0,0.15),-1.67256px -1.5588px 10.8px rgba(0,0,0,0.15),inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,backdropFilter: 'blur(4.392px)',transform:`matrix(-1, 0, 0, 1, 490, 0)`}}>
      
      <path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z" fill="#7F38F3" fill-opacity="0.15" style={{mixBlendMode:"plus-lighter"}}/>
      </g>
      <defs>
      <filter id="filter0_ddii_2_164" x="0.764704" y="0.447203" width="488.7" height="289.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1.67256" dy="-1.5588"/>
      <feGaussianBlur stdDeviation="5.4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="BackgroundImageFix" result="effect1_dropShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-10.0354" dy="-9.3528"/>
      <feGaussianBlur stdDeviation="21.6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="effect1_dropShadow_2_164" result="effect2_dropShadow_2_164"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_164" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.970085" dy="0.904104"/>
      <feGaussianBlur stdDeviation="1.944"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="shape" result="effect3_innerShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1.80636" dy="1.6835"/>
      <feGaussianBlur stdDeviation="3.888"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="effect3_innerShadow_2_164" result="effect4_innerShadow_2_164"/>
      </filter>
      <clipPath id="bgblur_0_2_164_clip_path" transform="translate(-0.764704 -0.447203)"><path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z"/>
      </clipPath></defs>
      </svg>
      

      {/* ---------- Frame 7 ---------- */}
      <svg width="490px" height="291px" viewBox="0 0 490 291" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute',left: 399, top: 193,transform: 'matrix(-1, 0, 0, 1, 0, 0)'}}>
      <foreignObject x="0.764704" y="0.447203" width="488.7" height="289.8">
          <div
            style={{
              position: 'absolute',
              width: 270,
              height: 39,
              top: 72,
              left: 138,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 32,
              lineHeight: '39px',
              textAlign: 'left',
              color: '#FFFFFF',
              transform: 'scaleX(-1)',
              zIndex: 22
            }}
          >
            Price Action
            <br></br>Analysis
          </div>
          <div
            style={{
              paddingTop: "70px",
              position: 'absolute',
              width: 400,
              height: 126.9,
              left: 'calc(50% - 435px / 2 - 8.1px)',
              top: 90,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 24,
              lineHeight: '26px',
              textAlign: 'left',
              color: 'rgba(255, 255, 255, 0.8)',
              transform: 'scaleX(-1)',
              zIndex: 22
            }}
          >
            Deep analysis of price movements and market psychology
          </div>
          <div
            style={{
              position: 'absolute',
              width: 251,
              height: 7.2,
              left: 170,
              top: 150,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 45,
              zIndex: 22
            }}
          />
        <div
          style={{
            position: 'absolute',
            width: 80.1,
            height: 80.1,
            left: 38,
            top: 54,
            background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.93181px 1.80041px 8.316px rgba(255,255,255,0.126),
                        inset 1.09553px 1.02101px 4.158px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(6.822px)',
            borderRadius: '50%',
            zIndex: 22
          }}
        >
          {/* Иконка-график */}
          <div>
          <svg width="10" height="32" viewBox="0 0 10 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "46px", top: "26px",transform:"scaleX(-1)"}}>
          <path d="M1.57495 0.5625H7.82495C8.6879 0.5625 9.38745 1.26206 9.38745 2.125V30.25C9.38745 31.1129 8.6879 31.8125 7.82495 31.8125H1.57495C0.712007 31.8125 0.0124512 31.1129 0.0124512 30.25V2.125C0.0124512 1.26206 0.712007 0.5625 1.57495 0.5625Z" fill="white" />
          </svg>
          <svg width="10" height="41" viewBox="0 0 10 41" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "34px", top: "17px",transform:"scaleX(-1)"}}>
          <path d="M2.07495 0.1875H8.32495C9.1879 0.1875 9.88745 0.887055 9.88745 1.75V39.25C9.88745 40.1129 9.1879 40.8125 8.32495 40.8125H2.07495C1.21201 40.8125 0.512451 40.1129 0.512451 39.25V1.75C0.512451 0.887055 1.21201 0.1875 2.07495 0.1875Z" fill="white"/>
          </svg>
          <svg width="10" height="23" viewBox="0 0 10 23" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left:"21px",top: "35px",transform:"scaleX(-1)"}}>
          <path d="M1.57495 0.9375H7.82495C8.6879 0.9375 9.38745 1.63706 9.38745 2.5V21.25C9.38745 22.1129 8.6879 22.8125 7.82495 22.8125H1.57495C0.712007 22.8125 0.0124512 22.1129 0.0124512 21.25V2.5C0.0124512 1.63706 0.712007 0.9375 1.57495 0.9375Z" fill="white"/>
          </svg>
          </div>
          <svg width="42" height="4" viewBox="0 0 42 4" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "18px", top: "57px",transform:"scaleX(-1)"}}>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M41.5125 2.25C41.5125 1.8356 41.3478 1.43817 41.0548 1.14514C40.7618 0.852119 40.3644 0.6875 39.95 0.6875H2.44995C2.03555 0.6875 1.63812 0.852119 1.3451 1.14514C1.05207 1.43817 0.887451 1.8356 0.887451 2.25C0.887451 2.6644 1.05207 3.06183 1.3451 3.35486C1.63812 3.64788 2.03555 3.8125 2.44995 3.8125H39.95C40.3644 3.8125 40.7618 3.64788 41.0548 3.35486C41.3478 3.06183 41.5125 2.6644 41.5125 2.25Z" fill="white"/>
          </svg>
        </div>
      </foreignObject><g filter="url(#filter0_ddii_2_164)" data-figma-bg-blur-radius="8.784" transform="scale(1)" style={{boxShadow: `-10.0354px -9.3528px 43.2px rgba(0,0,0,0.15),-1.67256px -1.5588px 10.8px rgba(0,0,0,0.15),inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,backdropFilter: 'blur(4.392px)',transform:`matrix(-1, 0, 0, 1, 490, 0)`}}>
      
      <path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z" fill="#7F38F3" fill-opacity="0.15" style={{mixBlendMode:"plus-lighter"}}/>
      </g>
      <defs>
      <filter id="filter0_ddii_2_164" x="0.764704" y="0.447203" width="488.7" height="289.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1.67256" dy="-1.5588"/>
      <feGaussianBlur stdDeviation="5.4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="BackgroundImageFix" result="effect1_dropShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-10.0354" dy="-9.3528"/>
      <feGaussianBlur stdDeviation="21.6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="effect1_dropShadow_2_164" result="effect2_dropShadow_2_164"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_164" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.970085" dy="0.904104"/>
      <feGaussianBlur stdDeviation="1.944"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="shape" result="effect3_innerShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1.80636" dy="1.6835"/>
      <feGaussianBlur stdDeviation="3.888"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="effect3_innerShadow_2_164" result="effect4_innerShadow_2_164"/>
      </filter>
      <clipPath id="bgblur_0_2_164_clip_path" transform="translate(-0.764704 -0.447203)"><path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z"/>
      </clipPath></defs>
      </svg>

      {/* ---------- Frame 8 ---------- */}
      <svg width="490px" height="291px" viewBox="0 0 490 291" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute',left: -33, top: 442,}}>
      <foreignObject x="0.764704" y="0.447203" width="488.7" height="289.8">
          <div
            style={{
              position: 'absolute',
              width: 280,
              height: 39,
              top: 85,
              left: 140,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 34.4,
              lineHeight: '39px',
              textAlign: 'left',
              color: '#FFFFFF',
              zIndex: 22
            }}
          >
            Risk Management
          </div>
          <div
            style={{
              paddingTop: "70px",
              position: 'absolute',
              width: 356.5,
              height: 126.9,
              left: 'calc(50% - 346.5px / 2 - 8.1px)',
              top: 85,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 26,
              lineHeight: '26px',
              textAlign: 'right',
              color: 'rgba(255, 255, 255, 0.8)',
              zIndex: 22
            }}
          >
            Advanced position sizing and risk calculation tools
          </div>
          <div
            style={{
              position: 'absolute',
              width: 251,
              height: 7.2,
              left: 170,
              top: 135,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 45,
              zIndex: 22
            }}
          />
        <div
          style={{
            position: 'absolute',
            width: 80.1,
            height: 80.1,
            left: 38,
            top: 54,
            background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.93181px 1.80041px 8.316px rgba(255,255,255,0.126),
                        inset 1.09553px 1.02101px 4.158px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(6.822px)',
            borderRadius: '50%',
            zIndex: 22
          }}
        >
          {/* Иконка-график */}
          <svg width="36" height="46" viewBox="0 0 36 46" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "22px", top: "18px",transform:"scaleX(-1)"}}>
          <path d="M18 0.5L0 7.25V20.9525C0 32.315 7.6725 42.9125 18 45.5C28.3275 42.9125 36 32.315 36 20.9525V7.25L18 0.5ZM31.5 20.9525C31.5 29.9525 25.7625 38.2775 18 40.82C10.2375 38.2775 4.5 29.975 4.5 20.9525V10.3775L18 5.315L31.5 10.3775V20.9525Z" fill="white"/>
          </svg>
        </div>
        <div
          style={{
            backdropFilter: 'blur(4.39px)',
            clipPath: 'url(#bgblur_0_2_164_clip_path)',
            height: '100%',
            width: '100%',
            inset: 0,
            zIndex: 0
          }}
        />
      </foreignObject><g filter="url(#filter0_ddii_2_164)" data-figma-bg-blur-radius="8.784" transform="scale(1)" style={{boxShadow: `-10.0354px -9.3528px 43.2px rgba(0,0,0,0.15),-1.67256px -1.5588px 10.8px rgba(0,0,0,0.15),inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,backdropFilter: 'blur(4.392px)',transform:`matrix(-1, 0, 0, 1, 490, 0)`}}>
      
      <path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z" fill="#7F38F3" fill-opacity="0.15" style={{mixBlendMode:"plus-lighter"}}/>
      </g>
      <defs>
      <filter id="filter0_ddii_2_164" x="0.764704" y="0.447203" width="488.7" height="289.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1.67256" dy="-1.5588"/>
      <feGaussianBlur stdDeviation="5.4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="BackgroundImageFix" result="effect1_dropShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-10.0354" dy="-9.3528"/>
      <feGaussianBlur stdDeviation="21.6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="effect1_dropShadow_2_164" result="effect2_dropShadow_2_164"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_164" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.970085" dy="0.904104"/>
      <feGaussianBlur stdDeviation="1.944"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="shape" result="effect3_innerShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1.80636" dy="1.6835"/>
      <feGaussianBlur stdDeviation="3.888"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="effect3_innerShadow_2_164" result="effect4_innerShadow_2_164"/>
      </filter>
      <clipPath id="bgblur_0_2_164_clip_path" transform="translate(-0.764704 -0.447203)"><path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z"/>
      </clipPath></defs>
      </svg>

      {/* ---------- Frame 9 ---------- */}
      <svg width="490px" height="291px" viewBox="0 0 490 291" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: 'absolute',left: 399, top: 442.5,transform: 'matrix(-1, 0, 0, 1, 0, 0)'}}>
      <foreignObject x="0.764704" y="0.447203" width="488.7" height="289.8">
          <div
            style={{
              position: 'absolute',
              width: 270,
              height: 39,
              top: 85,
              left: 148,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 34.4,
              lineHeight: '39px',
              textAlign: 'left',
              color: '#FFFFFF',
              transform: 'scaleX(-1)',
              zIndex: 22
            }}
          >
            Trade Journaling
          </div>
          <div
            style={{
              paddingTop: "70px",
              position: 'absolute',
              width: 356.5,
              height: 126.9,
              left: 'calc(50% - 346.5px / 2 - 8.1px)',
              top: 85,
              fontFamily: `'SF Pro', sans-serif`,
              fontStyle: 'normal',
              fontWeight: 510,
              fontSize: 26,
              lineHeight: '26px',
              textAlign: 'left',
              color: 'rgba(255, 255, 255, 0.8)',
              transform: 'scaleX(-1)',
              zIndex: 22
            }}
          >
            Track and analyze your trading performance over time
          </div>
          <div
            style={{
              position: 'absolute',
              width: 251,
              height: 7.2,
              left: 170,
              top: 135,
              background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
              borderRadius: 45,
              zIndex: 22
            }}
          />
        <div
          style={{
            position: 'absolute',
            width: 80.1,
            height: 80.1,
            left: 38,
            top: 54,
            background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
            mixBlendMode: 'normal',
            boxShadow: `-10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,0.15),
                        -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,0.15),
                        inset 1.93181px 1.80041px 8.316px rgba(255,255,255,0.126),
                        inset 1.09553px 1.02101px 4.158px rgba(255,255,255,0.126)`,
            backdropFilter: 'blur(6.822px)',
            borderRadius: '50%',
            zIndex: 22
          }}
        >
          {/* Иконка-график */}
          <svg width="44" height="37" viewBox="0 0 44 37" fill="none" xmlns="http://www.w3.org/2000/svg" style={{position: "absolute", left: "18px", top: "22px"}}>
          <path d="M22 34.1666C24.9644 32.4551 28.327 31.5541 31.75 31.5541C35.173 31.5541 38.5356 32.4551 41.5 34.1666V5.99996C38.5356 4.28847 35.173 3.38745 31.75 3.38745C28.327 3.38745 24.9644 4.28847 22 5.99996M22 34.1666C19.0356 32.4551 15.673 31.5541 12.25 31.5541C8.82703 31.5541 5.46437 32.4551 2.5 34.1666V5.99996C5.46437 4.28847 8.82703 3.38745 12.25 3.38745C15.673 3.38745 19.0356 4.28847 22 5.99996M22 34.1666V5.99996" stroke="white" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div
          style={{
            backdropFilter: 'blur(4.39px)',
            clipPath: 'url(#bgblur_0_2_164_clip_path)',
            height: '100%',
            width: '100%',
            inset: 0,
            zIndex: 0
          }}
        />
      </foreignObject><g filter="url(#filter0_ddii_2_164)" data-figma-bg-blur-radius="8.784" transform="scale(1)" style={{boxShadow: `-10.0354px -9.3528px 43.2px rgba(0,0,0,0.15),-1.67256px -1.5588px 10.8px rgba(0,0,0,0.15),inset 1.80636px 1.6835px 7.776px rgba(255,255,255,0.15),inset 0.970085px 0.904104px 3.888px rgba(255,255,255,0.15)`,backdropFilter: 'blur(4.392px)',transform:`matrix(-1, 0, 0, 1, 490, 0)`}}>
      
      <path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z" fill="#7F38F3" fill-opacity="0.15" style={{mixBlendMode:"plus-lighter"}}/>
      </g>
      <defs>
      <filter id="filter0_ddii_2_164" x="0.764704" y="0.447203" width="488.7" height="289.8" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-1.67256" dy="-1.5588"/>
      <feGaussianBlur stdDeviation="5.4"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="BackgroundImageFix" result="effect1_dropShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="-10.0354" dy="-9.3528"/>
      <feGaussianBlur stdDeviation="21.6"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
      <feBlend mode="plus-darker" in2="effect1_dropShadow_2_164" result="effect2_dropShadow_2_164"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_2_164" result="shape"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="0.970085" dy="0.904104"/>
      <feGaussianBlur stdDeviation="1.944"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="shape" result="effect3_innerShadow_2_164"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="1.80636" dy="1.6835"/>
      <feGaussianBlur stdDeviation="3.888"/>
      <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
      <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"/>
      <feBlend mode="plus-lighter" in2="effect3_innerShadow_2_164" result="effect4_innerShadow_2_164"/>
      </filter>
      <clipPath id="bgblur_0_2_164_clip_path" transform="translate(-0.764704 -0.447203)"><path d="M408.6 142.1C383.996 142.1 364.05 122.154 364.05 97.55C364.05 72.9457 344.104 53 319.5 53H99.0001C74.1473 53 54.0001 73.1472 54.0001 98V211.4C54.0001 236.253 74.1472 256.4 99.0001 256.4H411.3C436.153 256.4 456.3 236.253 456.3 211.4V187.1C456.3 162.247 436.153 142.1 411.3 142.1H408.6Z"/>
      </clipPath></defs>
      </svg>
      

      {/* ---------- Декоративные эллипсы ---------- */}
      <div
        style={{
          position: 'absolute',
          width: 25.6,
          height: 25.6,
          left: 415,
          top: 89,
          background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
          borderRadius: '50%',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: 25.6,
          height: 25.6,
          left: 415.2,
          top: 334.7,
          background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
          borderRadius: '50%',
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: 25.6,
          height: 25.6,
          left: 415,
          top: 591,
          background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
          borderRadius: '50%',
        }}
      />
    </div>
  </>
);